export function radar_klimadaten(type, title, unit) {

  $(function () {

      let selector = $('#'+type)


      let current_data = selector.attr('data-current').split(",").map(x => Number(x))
      let last_year_data = selector.attr('data-last-year').split(",").map(x => Number(x))
      let last_years_data = selector.attr('data-last-years').split(",").map(x => Number(x))

      let last_year = new Date().getFullYear() - 1

      // console.log("current" + current_data)
      // console.log("last" + last_year_data)
      // console.log("years" + last_years_data)

      Highcharts.chart(type, {

          colors: ['#95DA3B', '#bbbbbb', '#4D759E'],
          chart: {
              type: 'column'
          },
          title: {
              text: title + ' ' + unit + ' (Messort Aalen)'
          },
          xAxis: {
              categories: ['Jan', 'Feb', 'Mär', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez']
          },
          yAxis: {
              //min: -1,
              title: {
                  text: unit
              }
          },
          plotOptions: {
              column: {
                  pointPadding: 0.2,
                  borderWidth: 0
              }
          }
          ,

          series: [
              {
                  name: "2012 - " + last_year,
                  data: last_years_data
              },
              {
                  //name: '2014',
                  name: last_year,
                  data:last_year_data
              },
              {
                  //name: '2015',
                  name: new Date().getFullYear(),
                  data: current_data
              }
          ]


      });

  });

}